import { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';



const Perfil = () => {
    const [perfil, setPerfil] = useState({
        codigo: '',
        nombre: '',
        usuario: '',
        contrasena: '',
        email: '',
        telefono: '',
        modificarContrasena: false,
    });

    const onChange = (field, value) => {
        setPerfil((prev) => ({ ...prev, [field]: value }));
    };

    return (
        <div className="p-2">
            <Card className="bg-blue-50 border-bottom-1 border-blue-200 py-2 px-3 mb-2">
                <h3 className="m-0 text-blue-700">Editar Perfil</h3>
            </Card>
            <Card className="p-3 surface-ground">
                <div className="grid p-fluid">
                    <div className="col-12">
                        <div className="flex align-items-center mb-2">
                            <label htmlFor="perfil-codigo" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">Código</label>
                            <label id="perfil-codigo" value={perfil.codigo} className="p-inputtext-sm w-full" />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="flex align-items-center mb-2">
                            <label htmlFor="perfil-nombre" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">Nombre</label>
                            <InputText id="perfil-nombre" value={perfil.nombre} onChange={(e) => onChange('nombre', e.target.value)} className="p-inputtext-sm w-full" />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="flex align-items-center mb-2">
                            <label htmlFor="perfil-usuario" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">Usuario</label>
                            <InputText id="perfil-usuario" value={perfil.usuario} onChange={(e) => onChange('usuario', e.target.value)} className="p-inputtext-sm w-full" />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="flex align-items-center mb-2">
                            <label htmlFor="perfil-contrasena" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">Contraseña</label>
                            <div className="flex align-items-center gap-2 w-full">
                                <InputText
                                    id="perfil-contrasena"
                                    type={perfil.modificarContrasena ? 'text' : 'password'}
                                    value={perfil.contrasena}
                                    onChange={(e) => onChange('contrasena', e.target.value)}
                                    className="p-inputtext-sm w-full md:w-12rem"
                                    disabled={!perfil.modificarContrasena}
                                />
                                <Checkbox
                                    inputId="perfil-modificar-contrasena"
                                    checked={perfil.modificarContrasena}
                                    onChange={(e) => onChange('modificarContrasena', e.checked)}
                                />
                                <label htmlFor="perfil-modificar-contrasena" className="text-sm cursor-pointer">modificar</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="flex align-items-center mb-2">
                            <label htmlFor="perfil-email" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">e-mail</label>
                            <InputText id="perfil-email" value={perfil.email} onChange={(e) => onChange('email', e.target.value)} className="p-inputtext-sm w-full" />
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="flex align-items-center mb-3">
                            <label htmlFor="perfil-telefono" className="font-medium text-sm mr-3 w-10rem flex-shrink-0">Teléfono</label>
                            <InputText id="perfil-telefono" value={perfil.telefono} onChange={(e) => onChange('telefono', e.target.value)} className="p-inputtext-sm w-full md:w-12rem" />
                        </div>
                    </div>

                    <div className="col-2 flex justify-content-center">
                        <Button label="Grabar" icon="pi pi-save" className="p-button-sm p-button-info" />
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default Perfil;
